export default "__VITE_ASSET__bDIlpjX5__"